import { useState, useEffect } from "react";
import { Offcanvas } from 'react-bootstrap';
import axios from "axios";
import { getOnlyToken } from '../../utils/commonFunctions';
import DataTable, { createTheme } from 'react-data-table-component';
import { createThemeData, customStyles } from './../../utils/Constants'
const Roles = () => {
    const [showPopup, setshowPopup] = useState(false);
    const [roles, setRoles] = useState([]);
    const [menus, setMenus] = useState([]);
    const [roleName, setRoleName] = useState("");
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const [editRoleId, setEditRoleId] = useState(null);
    const [modalMessage, setModalMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("success");
    const [deleteRoleId, setDeleteRoleId] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [selectAll, setSelectAll] = useState({
        view: false,
        add: false,
        edit: false,
        delete: false,
        download: false
    });
    const [errors, setErrors] = useState({});
    createTheme('solarized', createThemeData, 'dark');

    const fetchRoles = async (page = 1, perPage = pageSize) => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        try {
            const response = await axios.get(`/api/sub_user/role-list/?page=${page}&per_page=${perPage}`, config);
            const resultData = response.data.results.data || [];
            const pagination = response.data.results.pagination || {};

            setRoles(resultData);
            console.log("Roles fetched:", response.data.results.data);
            
            setCurrentPage(pagination.current_page || page);
            setPageSize(pagination.per_page || perPage);
            setTotalRows(pagination.total_posts || 0);   
        } catch (error) {
            console.error("Failed to fetch roles:", error);
        }
    };


    useEffect(() => {
        fetchRoles(currentPage, pageSize);
    }, []);

    const handlePageChange = (page) => {
        fetchRoles(page, pageSize);
    };

    const handlePerRowsChange = (newPerPage, page = currentPage) => {
        setPageSize(newPerPage);
        fetchRoles(page, newPerPage);
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };


    const fetchMenuData = async () => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            const response = await axios.get(`/api/sub_user/get_customer_menu_data/`, config);
            const menuData = response.data.results?.data?.menu_data || [];
            setMenus(menuData);
        } catch (error) {
            console.error('Failed to fetch menu data:', error);
        }
    };

    useEffect(() => {
        if (showPopup) {
            fetchMenuData();
        }
    }, [showPopup]);

    const handleSelectAll = (permissionType) => {
        const newValue = !selectAll[permissionType];
        
        setSelectAll(prev => ({
            ...prev,
            [permissionType]: newValue
        }));

        setSelectedPermissions(prev => {
            const updated = {};
            menus.forEach(menu => {
                const actions = menu.page_action || {};
                const current = prev[menu.id] || {};
                
                updated[menu.id] = {
                    ...current,
                    [permissionType]: newValue && (
                        permissionType === 'view' || 
                        (permissionType === 'add' && actions.add === 1) ||
                        (permissionType === 'edit' && actions.edit === 1) ||
                        (permissionType === 'delete' && actions.delete === 1) ||
                        (permissionType === 'download' && actions.download === 1)
                    ),
                    // If unchecking view, uncheck all others
                    ...(permissionType === 'view' && !newValue ? {
                        add: false,
                        edit: false,
                        delete: false,
                        download: false
                    } : {})
                };
            });
            return updated;
        });

        // Update other select all states if view is unchecked
        if (permissionType === 'view' && !newValue) {
            setSelectAll(prev => ({
                ...prev,
                add: false,
                edit: false,
                delete: false,
                download: false
            }));
        }
    };

    const handleCheckboxChange = (menuId, type) => {
        setSelectedPermissions(prev => {
            const current = prev[menuId] || {};
            const updated = {
                ...prev,
                [menuId]: {
                    ...current,
                    [type]: !current[type],
                    ...(type === "view" && !current.view
                        ? {}
                        : type === "view" && current.view
                            ? { add: false, edit: false, delete: false, download: false }
                            : {})
                }
            };
            return updated;
        });

        // Update select all states based on current permissions
        setTimeout(() => {
            const updatedSelectAll = {
                view: menus.every(menu => selectedPermissions[menu.id]?.view),
                add: menus.filter(menu => menu.page_action?.add === 1).every(menu => selectedPermissions[menu.id]?.add),
                edit: menus.filter(menu => menu.page_action?.edit === 1).every(menu => selectedPermissions[menu.id]?.edit),
                delete: menus.filter(menu => menu.page_action?.delete === 1).every(menu => selectedPermissions[menu.id]?.delete),
                download: menus.filter(menu => menu.page_action?.download === 1).every(menu => selectedPermissions[menu.id]?.download)
            };
            setSelectAll(updatedSelectAll);
        }, 0);
    };

    const validateForm = () => {
        const newErrors = {};

        // Validate role name
        if (!roleName.trim()) {
            newErrors.roleName = "Role name is required";
        } else if (roleName.trim().length < 3) {
            newErrors.roleName = "Role name must be at least 3 characters";
        } else if (roleName.trim().length > 50) {
            newErrors.roleName = "Role name cannot exceed 50 characters";
        } else if (!/^[A-Za-z\s]+$/.test(roleName.trim())) {
            newErrors.roleName = "Role name should contain only letters and spaces";
        }

        // Validate permissions
        const hasPermissions = Object.values(selectedPermissions).some(permissions =>
            Object.values(permissions).some(permission => permission)
        );
        
        if (!hasPermissions) {
            newErrors.permissions = "Please select at least one menu permission";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSaveRole = async () => {
        if (!validateForm()) {
            return;
        }

        const parentIds = Object.keys(selectedPermissions)
            .filter(menuId => Object.values(selectedPermissions[menuId]).some(v => v))
            .join(',');

        const getIdsByAction = (action) =>
            Object.entries(selectedPermissions)
                .filter(([_, actions]) => actions[action])
                .map(([menuId]) => menuId)
                .join(',');

        const payload = {
            role_name: roleName,
            parent_id: parentIds,
            menu_id_view: getIdsByAction("view"),
            menu_id_add: getIdsByAction("add"),
            menu_id_edit: getIdsByAction("edit"),
            menu_id_delete: getIdsByAction("delete"),
            menu_id_download: getIdsByAction("download"),
        };

        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            let response;
            if (editRoleId) {
                response = await axios.put(
                    `/api/sub_user/edit_role/${editRoleId}/`,
                    payload,
                    config
                );
                setModalMessage(response.data?.message || "Role updated successfully");
            } else {
                response = await axios.post(
                    `/api/sub_user/role/`,
                    payload,
                    config
                );
                setModalMessage(response.data?.message || "Role created successfully");
            }

            setModalType("success");
            setShowModal(true);
            fetchRoles();
            setshowPopup(false);
            setEditRoleId(null);
            setSelectedPermissions({});
            setRoleName("");
        } catch (error) {
            console.error("Error saving role:", error);
            setModalType("error");
            setModalMessage(error?.response?.data?.message || "Failed to save role. Please try again.");
            setShowModal(true);
        }
    };



    const handleEditClick = (role) => {
        setRoleName(role.role_name);
        setEditRoleId(role.id);
        const permissionMap = {};

        const viewIds = role.menu_id_view?.split(',') || [];
        const addIds = role.menu_id_add?.split(',') || [];
        const editIds = role.menu_id_edit?.split(',') || [];
        const deleteIds = role.menu_id_delete?.split(',') || [];
        const downloadIds = role.menu_id_download?.split(',') || [];

        const allIds = new Set([...viewIds, ...addIds, ...editIds, ...deleteIds, ...downloadIds]);
        allIds.forEach(id => {
            permissionMap[id] = {
                view: viewIds.includes(id),
                add: addIds.includes(id),
                edit: editIds.includes(id),
                delete: deleteIds.includes(id),
                download: downloadIds.includes(id),
            };
        });

        setSelectedPermissions(permissionMap);
        
        // Update select all states based on loaded permissions
        setTimeout(() => {
            const updatedSelectAll = {
                view: Object.values(permissionMap).every(p => p.view),
                add: Object.values(permissionMap).filter((p, index) => menus[index]?.page_action?.add === 1).every(p => p.add),
                edit: Object.values(permissionMap).filter((p, index) => menus[index]?.page_action?.edit === 1).every(p => p.edit),
                delete: Object.values(permissionMap).filter((p, index) => menus[index]?.page_action?.delete === 1).every(p => p.delete),
                download: Object.values(permissionMap).filter((p, index) => menus[index]?.page_action?.download === 1).every(p => p.download)
            };
            setSelectAll(updatedSelectAll);
        }, 100);
        
        setshowPopup(true);
    };

    const handleDeleteClick = (roleId) => {
        setDeleteRoleId(roleId);
        setShowDeleteConfirm(true);
    };

    const confirmDeleteRole = async () => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        try {
            const response = await axios.delete(`/api/sub_user/role_delete/${deleteRoleId}/`, config);
            setSuccessMessage(response.data.message || "Role deleted successfully!");
            setShowSuccessModal(true);
            fetchRoles();
        } catch (error) {
            console.error("Error deleting role:", error);
        } finally {
            setShowDeleteConfirm(false);
            setDeleteRoleId(null);
        }
    };


    return (
        <>
            <div className="row mb-3">
                <div className="mb-3 d-flex flex-column flex-md-row-reverse align-items-start align-items-md-center justify-content-between gap-2">
                    <button className="btn btn-success mt-0 page-title-right" onClick={() => {
                        setshowPopup(true);
                        setRoleName("");
                        setSelectedPermissions({});
                        setSelectAll({
                            view: false,
                            add: false,
                            edit: false,
                            delete: false,
                            download: false
                        });
                        setErrors({});
                        setEditRoleId(null);
                    }}>
                        <i className="ri-user-add-line"></i> Add New Role
                    </button>

                    <div className="page-title-left">
                        <div className="app-search">
                            <form>
                                <div className="position-relative">
                                    <input type="text" className="form-control border border-dark border-opacity-10" placeholder="Search files..." />
                                    <span className="ri-search-line search-icon"></span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <DataTable
                    columns={[
                        {
                            name: "S.No",
                            cell: (row, index) => (
                                <>{(currentPage - 1) * pageSize + index + 1}</>
                            ),
                            width: "80px"
                        },
                        {
                            name: "User Role",
                            selector: row => row.role_name || "-",
                        },
                        {
                            name: "Status",
                            cell: row => (
                                <span className="badge badge-outline-success">
                                    {row.status ? "Active" : "Inactive"}
                                </span>
                            )
                        },
                        {
                            name: "Action",
                            cell: row => (
                                <div className="col-auto">
                                    <button className="btn btn-link text-warning btn-lg p-0 me-1" onClick={() => handleEditClick(row)}>
                                        <i className="ri-edit-box-line"></i>
                                    </button>
                                    <button className="btn btn-link text-danger btn-lg p-0" onClick={() => handleDeleteClick(row.id)}>
                                        <i className="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            ),
                        }
                    ]}
                    data={roles}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={pageSize}
                    paginationDefaultPage={currentPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationComponentOptions={paginationComponentOptions}
                    persistTableHead
                    highlightOnHover
                    responsive
                    striped
                    noHeader
                    theme="solarized"
                    customStyles={customStyles}
                />


            </div>

            <Offcanvas show={showPopup} onHide={() => setshowPopup(false)} placement="end" style={{ width: '700px' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{editRoleId ? 'Edit Role' : 'Add New Role'}</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <div className="mb-3">
                        <label htmlFor="roleName" className="form-label">
                            User Role <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-control ${errors.roleName ? 'is-invalid' : ''}`}
                            id="roleName"
                            placeholder="Enter Role Name"
                            value={roleName}
                            onChange={(e) => {
                                setRoleName(e.target.value);
                                if (errors.roleName) {
                                    setErrors(prev => ({ ...prev, roleName: '' }));
                                }
                            }}
                        />
                        {errors.roleName && <div className="invalid-feedback">{errors.roleName}</div>}
                    </div>

                    <div>
                        <h5>Role Permissions <span className="text-danger">*</span></h5>
                        {errors.permissions && (
                            <div className="alert alert-danger py-2 mb-3">
                                <small>{errors.permissions}</small>
                            </div>
                        )}
                        
                        {/* Select All Row */}
                        {menus.length > 0 && (
                            <div className="card mb-3">
                                <div className="card-body py-2">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="fw-bold">
                                            <i className="ri-select-all-line me-2"></i>
                                            Select All
                                        </div>
                                        <div className="d-flex flex-wrap gap-3">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="selectAllView"
                                                    checked={selectAll.view}
                                                    onChange={() => handleSelectAll("view")}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="selectAllView">View</label>
                                            </div>

                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="selectAllAdd"
                                                    checked={selectAll.add}
                                                    disabled={!selectAll.view}
                                                    onChange={() => handleSelectAll("add")}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="selectAllAdd">Add</label>
                                            </div>

                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="selectAllEdit"
                                                    checked={selectAll.edit}
                                                    disabled={!selectAll.view}
                                                    onChange={() => handleSelectAll("edit")}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="selectAllEdit">Edit</label>
                                            </div>

                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="selectAllDelete"
                                                    checked={selectAll.delete}
                                                    disabled={!selectAll.view}
                                                    onChange={() => handleSelectAll("delete")}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="selectAllDelete">Delete</label>
                                            </div>

                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="selectAllDownload"
                                                    checked={selectAll.download}
                                                    disabled={!selectAll.view}
                                                    onChange={() => handleSelectAll("download")}
                                                />
                                                <label className="form-check-label fw-bold" htmlFor="selectAllDownload">Download</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        <ul className="list-group">
                            {menus.map((menu, index) => {
                                const actions = menu.page_action || {};
                                return (
                                    <li key={menu.id} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <i className={`${menu.menu_icons} me-2`} />
                                            {menu.menu_name}
                                        </div>
                                        <div className="mt-2">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`view-${index}`}
                                                    checked={selectedPermissions[menu.id]?.view || false}
                                                    onChange={() => {
                                                        handleCheckboxChange(menu.id, "view");
                                                        if (errors.permissions) {
                                                            setErrors(prev => ({ ...prev, permissions: '' }));
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`view-${index}`}>View</label>
                                            </div>

                                            {actions.add === 1 && (
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`add-${index}`}
                                                        checked={selectedPermissions[menu.id]?.add || false}
                                                        disabled={!selectedPermissions[menu.id]?.view}
                                                        onChange={() => handleCheckboxChange(menu.id, "add")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`add-${index}`}>Add</label>
                                                </div>
                                            )}

                                            {actions.edit === 1 && (
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`edit-${index}`}
                                                        checked={selectedPermissions[menu.id]?.edit || false}
                                                        disabled={!selectedPermissions[menu.id]?.view}
                                                        onChange={() => handleCheckboxChange(menu.id, "edit")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`edit-${index}`}>Edit</label>
                                                </div>
                                            )}

                                            {actions.delete === 1 && (
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`delete-${index}`}
                                                        checked={selectedPermissions[menu.id]?.delete || false}
                                                        disabled={!selectedPermissions[menu.id]?.view}
                                                        onChange={() => handleCheckboxChange(menu.id, "delete")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`delete-${index}`}>Delete</label>
                                                </div>
                                            )}

                                            {actions.download === 1 && (
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`download-${index}`}
                                                        checked={selectedPermissions[menu.id]?.download || false}
                                                        disabled={!selectedPermissions[menu.id]?.view}
                                                        onChange={() => handleCheckboxChange(menu.id, "download")}
                                                    />
                                                    <label className="form-check-label" htmlFor={`download-${index}`}>Download</label>
                                                </div>
                                            )}
                                        </div>
                                    </li>

                                );
                            })}
                        </ul>
                    </div>

                    <div className="offcanvas-footer text-center mt-4">
                        <button className="btn btn-warning me-2 px-4" type="button" onClick={() => setshowPopup(false)}>Cancel</button>
                        <button 
                            className="btn btn-success px-4" 
                            type="button" 
                            onClick={handleSaveRole}
                            disabled={Object.keys(errors).length > 0}
                        >
                            {editRoleId ? "Update Role" : "Save Changes"}
                        </button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className={`modal-content border-${modalType === 'success' ? 'success' : 'danger'}`}>
                            <div className={`modal-header bg-${modalType === 'success' ? 'success' : 'danger'} text-white`}>
                                <h5 className="modal-title">{modalType === "success" ? "Success" : "Error"}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <p>{modalMessage}</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteConfirm && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Delete</h5>
                                <button type="button" className="btn-close" onClick={() => setShowDeleteConfirm(false)}></button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to delete this role?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteConfirm(false)}>Cancel</button>
                                <button type="button" className="btn btn-danger" onClick={confirmDeleteRole}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Success Message Modal */}
            {showSuccessModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Success</h5>
                                <button type="button" className="btn-close" onClick={() => setShowSuccessModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <p>{successMessage}</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => setShowSuccessModal(false)}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}




        </>
    );
};

export default Roles;